// GromAuktion admin adapter (module-local, mirrors screens/gifts/giftApi.ts). Backend:
// MyTelegram.AdminServer's GromAuktionAdminController, over the real EventFlow command bus +
// GromAuktionListingAggregate/StarsWalletAggregate read models (not plain reference data - every
// write here replays/audits like any other domain command).
import { api } from '@/lib/api'

export interface AdminGromAuktionListing {
  id: string
  username: string
  seller_user_id: number
  price: number
  is_retroactive: boolean
  status: 'active' | 'sold' | 'delisted'
  buyer_user_id: number | null
  created_at: number
  sold_at: number | null
  is_auction: boolean
  auction_end_at: number
  min_bid_increment: number
  current_bid: number
  current_bidder_id: number | null
  is_number: boolean
}

export async function fetchListings(search?: string): Promise<AdminGromAuktionListing[]> {
  const data = await api.get<AdminGromAuktionListing[]>('/admin/gromauktion/listings', {
    query: { skip: 0, limit: 500 },
  })
  const rows = data ?? []
  return search
    ? rows.filter((r) => r.username.toLowerCase().includes(search.toLowerCase()))
    : rows
}

export interface CreateListingRequest {
  username: string
  seller_user_id: number
  price: number
  is_number?: boolean
}

export async function createListing(request: CreateListingRequest): Promise<{ id: string }> {
  return api.post<{ id: string }>('/admin/gromauktion/listings', request)
}

export interface CreateAuctionRequest {
  username: string
  seller_user_id: number
  starting_price: number
  min_bid_increment: number
  duration_seconds: number
  is_number?: boolean
}

export async function createAuction(request: CreateAuctionRequest): Promise<{ id: string }> {
  return api.post<{ id: string }>('/admin/gromauktion/listings/auction', request)
}

export async function delistListing(id: string): Promise<void> {
  await api.post(`/admin/gromauktion/listings/${id}/delist`)
}

export async function repriceListing(id: string, price: number): Promise<void> {
  await api.post(`/admin/gromauktion/listings/${id}/price`, { price })
}

export interface MigrateRetroactiveResult {
  created: string[]
  skipped: string[]
}

export async function migrateRetroactive(): Promise<MigrateRetroactiveResult> {
  return api.post<MigrateRetroactiveResult>('/admin/gromauktion/migrate-retroactive')
}
